module.exports = __webpack_public_path__ + "static/media/plaster.42bd6b80.png";